export default __webpack_public_path__ + "static/media/triangle.e18bceb9.svg";